import React from "react";
import TorqueCalculator from "./components/TorqueCalculator";

function App() {
  return (
    <div className="app-container">
      <TorqueCalculator />
    </div>
  );
}

export default App;
